"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { FormPasswordInput } from "@/components/ui/password-input";
import { ProviderType } from "@/types/dataProvider";
import type { BaseProviderFormProps } from "./base-provider-form";
export const YardiProviderForm = t0 => {
  const $ = _c(3);
  const {
    form,
    isCreating
  } = t0;
  let t1;
  if ($[0] !== form || $[1] !== isCreating) {
    t1 = <FormPasswordInput autoComplete="new-password" disabled={isCreating} form={form} label="API Key" name="data.credentials.apiKey" placeholder="Enter new API key" type="password" />;
    $[0] = form;
    $[1] = isCreating;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
(YardiProviderForm as any).providerType = ProviderType.YARDI;